module.exports = __webpack_public_path__ + "img/thumb_hawthorn.fd5ce191.jpg";